import { NgModule } from '@angular/core';
import { SharedModule } from 'app/shared/shared.module';
import { AddressComponent } from './address.component';
import { TabsComponentModule } from '../tabs-component/tabs-component.module';
import { ContactInfoFormModule } from '../contact-info/contact-info.module';

@NgModule({
    declarations: [
        AddressComponent
    ],
    imports: [
        SharedModule,
        TabsComponentModule,
        ContactInfoFormModule
    ],
    exports: [
        AddressComponent
    ]
})
export class AddressModule {}
